export const SET_PROFILES_LIST = 'SET_PROFILES_LIST';
export const SET_SAVE_PROFILE_MODAL_OPEN = 'SET_SAVE_PROFILE_MODAL_OPEN';